import { useQuery } from '@apollo/client';

import { getCharityGroupTypeExternalId } from '@/utils/auth';
import GetCharity from '../../src/queries/GetCharity.gql';
import { GetCharityQuery, GetCharityQueryVariables } from 'types/graphql';

export function useCharity(charityId?: string) {
  const id = charityId ?? getCharityGroupTypeExternalId();
  return useQuery<GetCharityQuery, GetCharityQueryVariables>(GetCharity, {
    variables: {
      charityId: id,
    },
    errorPolicy: 'all',
  });
}
